/**
 * Componente de adição de Configuração de Comissionamento
 *
 * @module App/CommissionConfig/Add
 */
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useState } from "react";
import { Form } from "../shared/Form";
import { registerCommissionConfigData } from "@/Api/commissionConfig";
import { ApiDataProps } from "@/pages/Tenants";
import { CommissionConfigData } from "@/types/commissionConfig";

type Props = {
  updateFront: (
    callback: (
      prev: ApiDataProps<CommissionConfigData>
    ) => ApiDataProps<CommissionConfigData>
  ) => void;
};

/**
 * Botão de adição com modal
 */
export function AddBtn({ updateFront }: Props) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: any) => {
    try {
      setLoading(true);

      const formattedValues = {
        ...values,
      };

      const { data, ok } = await registerCommissionConfigData(formattedValues);

      if (ok) {
        toast.success(data?.message || "Configuração criada com sucesso!");
        updateFront((prev) => ({
          ...prev,
          data: [data.response, ...(prev?.data || [])],
        }));
        setOpen(false);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="flex items-center gap-2 bg-primary">
          <Plus className="h-4 w-4" />
          Criar
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-[800px] max-h-[90vh] overflow-y-auto">
        <Form
          title="Criar Configuração de Comissionamento"
          loading={loading}
          onSubmit={handleSubmit}
          buttonText="Criar"
        />
      </DialogContent>
    </Dialog>
  );
}
